import {
  props,
} from './utils'

const store = state => state.snackbar

export default {
  store,
  ...props(store, [
    'open',
    'text',
    'type',
  ]),
}
